export const DATE_DROPDOWN_OPTIONS = [
  {
    label: 'yesterday',
    value: 1
  },
  {
    label: 'last week',
    value: 7,
  }, 
  {
    label: 'last month',
    value: 30,
  },
  {
    label: 'last 3 months',
    value: 90,
  },
  {
    label: 'last 6 months',
    value: 180
  },
  {
    label: 'last year',
    value: 365
  }
]

export const DATE_DROPDOWN_DEFAULT = DATE_DROPDOWN_OPTIONS[2]

export default {
  DATE_DROPDOWN_OPTIONS
}



// WEBPACK FOOTER //
// ./src/constants/tables.js